import React from "react";
import MxButton2 from "./MxButton2";
import MapIcon from "@/assets/icons/google_maps.svg?react";

interface MxButtonLocationProps {
  onClick?: () => void;
  children?: React.ReactNode;
  disabled?: boolean;
  latitude: number;
  longitude: number;
}

const MxButtonLocation = (props: MxButtonLocationProps) => {
  const { latitude, longitude, ...rest } = props;
  const onClick = () => {
    const url = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(url, "_blank");
  };
  return (
    <MxButton2
      {...rest}
      testId="mx-button-location"
      variant="contained"
      disabled={props.disabled}
      endIcon={<MapIcon width={20} height={20} />}
      textColor="primary.contrastText"
      onClick={onClick}
    />
  );
};

export default MxButtonLocation;
